import { shareDocumentWithPatient } from 'api/Documents';

import { showAlert } from 'components/shared/Alert/Alert';

import setMultipleQueriesData from '../setMultipeQueriesData';

export default async function handleShareWithPatient({
  type,
  id,
  setShareLoading,
  showConfirmation,
  patientId,
  navigate,
  queryClient,
  setShowConfirmation,
  initConfirmation
}) {
  setShareLoading(true);
  const isUnshare = showConfirmation?.unshare || false;
  const { success, email } = await shareDocumentWithPatient(navigate, {
    patientId,
    type,
    id,
    ...(isUnshare ? { unshare: true } : {})
  });

  const message = success
    ? `Document ${isUnshare ? 'un' : ''}shared with patient successfully${!email && !isUnshare ? ', but the email failed' : ''}.`
    : `There was a problem  ${isUnshare ? 'un' : ''}sharing the document with the patient.`;

  const color = success ? 'success' : 'danger';

  showAlert({ message, color });

  setMultipleQueriesData(queryClient, ['chart-documents', 'practice-documents'], (old) => {
    return {
      ...old,
      documents: old?.documents?.map((item) => {
        if (item?.id === id) {
          return {
            ...item,
            myportal: !isUnshare
          };
        } else {
          return item;
        }
      })
    };
  });

  if (success) setShowConfirmation(initConfirmation);
  setShareLoading(false);
}
